<template>
  <card shadow footerClasses="py-2 text-center" bodyClasses="p-1">
    <div slot="header" class="bg-white border-0">
      <div class="row align-items-center">
        <div class="col-8">
          <h3 class="mb-0">
            Chamada para startups
            <span class="text-warning">STARS</span>
          </h3>
        </div>
      </div>
    </div>
    <template>
      <div class="row text-center">
        <div class="col-md-4 mt-2">
          <img src="/img/pages/rocket.png" width="150" alt="..." />
          <h3 class="mt-3">
            <span class="bg-white rounded border p-2">{{ call.name }}</span>
          </h3>
          <h3 class="font-weight-normal">
            Programa de
            <span class="text-orange">{{ call.type }}</span>
          </h3>
        </div>
        <div class="col-md-8">
          <div
            class="card-profile-stats d-flex justify-content-center small pb-0 mb-1"
          >
            <div>
              <span class="heading">{{ formatValue(call.max_value) }}</span>
              <span class="description">Investimento máximo</span>
            </div>
            <div>
              <span class="heading">{{ call.max_equity + " %" || "-" }}</span>
              <span class="description">Percentual máximo</span>
            </div>
            <div>
              <span class="heading">{{ call.max_startups || "N/A" }}</span>
              <span class="description">Máximo de startups</span>
            </div>
          </div>
          <h4 class="mb-4" v-if="call.sectors">
            Setores:
            <span class="font-weight-light">
              <base-button
                size="sm"
                v-for="(sector, index) in call.sectors"
                :key="'sector_' + index"
                :type="bgClasses[index % bgClasses.length]"
              >
                {{ sector }}
              </base-button>
            </span>
          </h4>
          <h4>
            Região:
            <span class="font-weight-light">
              {{ call.region || "-" }}
              <badge type="warning" v-if="call.region_limited">
                <i class="fas fa-lock mr-1"></i> inscrições limitadas a startups
                da região
              </badge>
            </span>
          </h4>
          <h4>
            Chamada aberta de:
            <span class="font-weight-light">
              {{ formatDate(call.start_date, "L") || "..." }} até
              {{ formatDate(call.end_date, "L") || "..." }}
            </span>
          </h4>
          <div v-if="count">
            <h4>
              Investidores cadastrados no fundo:
              <badge type="info" class="p-2">{{ count.investors }}</badge>
            </h4>
            <h4>
              Startups inscritas:
              <badge type="info" class="p-2">{{ count.subscriptions }}</badge>
            </h4>
          </div>
        </div>
      </div>
    </template>
    <div slot="footer">
      <base-button
        type="white"
        @click="$router.push(`/admin/chamadas/${call.id}/editar`)"
        ><i class="fas fa-edit text-info mr-2"></i>Editar chamada</base-button
      >
    </div>
  </card>
</template>
<script>
export default {
  name: "call-card",
  props: {
    call: {
      type: Object,
      required: true,
      description: "Startup call",
    },
    count: {
      type: Object,
      description: "Investor and subscription count",
    },
  },
  data() {
    return {
      bgClasses: [
        "warning",
        "info",
        "primary",
        "success",
        "secondary",
        "danger",
        "light",
        "dark",
      ],
    };
  },
};
</script>
<style scoped>
.card-profile-stats > div .heading {
  font-size: 1rem;
}
</style>
